import axios from 'axios';
import crypto from 'crypto-browserify';

function macEncrypt(stringToSign, secret) {
    const algorithm = 'sha256';


    // Create a HMAC instance with the HmacSHA256 algorithm
    const hmac = crypto.createHmac(algorithm, secret);

    // Calculate the HMAC
    const hmacBytes = hmac.update(stringToSign, 'utf8').digest();

    // Convert the bytes to a hexadecimal string
    let hexString = '';
    for (const byte of hmacBytes) {
        const hex = byte.toString(16);
        hexString += hex.length === 1 ? '0' + hex : hex;
    }

    return hexString;
}

function getFormattedTimestamp() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Bulan 0-11
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}${month}${day}${hours}${minutes}${seconds}`;
}

function generateSimpleKey(length) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
}

export async function post(url, callback, callbackError, header) {
    if (header === undefined) {
        header = {};
    }
    try {
        const response = await axios.post(url,
            {}, {
                headers: header
            });
        callback(response.data);
    } catch (err) {
        callbackError(err);
    }
}

export async function postDanai(url, callback, callbackError) {
    const timestamp = getFormattedTimestamp()
    const id = generateSimpleKey(32)
    const key = "5f4dcc3b5aa765d61d8327deb882cf99"
    const stringToSign = "POST:" + timestamp + ":" + id
    const enstringToSign = macEncrypt(stringToSign.toUpperCase(), key)
    try {
        const response = await axios.post(url,
            {}, {
                headers: {
                    'X-Date': timestamp,
                    'X-Id': id,
                    'X-Sign': key,
                    'stringToSign': enstringToSign,
                    'Content-Type': 'application/json'
                }
            });
        callback(response.data);
    } catch (err) {
        callbackError(err);
    }
}